import { render, staticRenderFns } from "./VsIcon.vue?vue&type=template&id=6d73b516"
import script from "./VsIcon.vue?vue&type=script&lang=js"
export * from "./VsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports